// libs
import { connect } from "react-redux";

// components
import CheckoutURI from "./CheckoutURI";

// selectors
import { getRemoteConfig } from "shared/store/remoteConfigs/selectors";

// helpers
import { getMapToState } from "./helpers";

const mapStateToProps = (state: any) => ({
    ...getMapToState(getRemoteConfig(state, "react_checkout")),
});

export default connect(mapStateToProps)(CheckoutURI);
